import { getLocale } from '../user/device-info';

function formatNumber( number: number ): string {
    if ( !window.Intl || number === 0 ) {
        return number.toString();
    }

    if ( !window.numberFormat ) {
        window.numberFormat = new Intl.NumberFormat( getLocale(), {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true,
        } );
    }

    return window.numberFormat.format( number );
}

function formatCurrency(
    number: number,
    currencyCode: string,
    currencySymbol: string,
    locale: string = getLocale(),
): string {
    if ( typeof Intl !== 'undefined' && currencyCode ) {
        try {
            return new Intl.NumberFormat( locale, {
                style: 'currency',
                currency: currencyCode,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            } ).format( number );
        } catch {
            // Fall back to the existing number formatter and supplied symbol.
        }
    }

    return `${currencySymbol} ${formatNumber( number )}`.trim();
}

export {
    formatCurrency,
    formatNumber,
};
